import React, { useState } from "react";
import { Tabs, Button, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { setUser } from "../redux/userSlice";
import axios from "axios";
import { toast } from "react-hot-toast";

const Notifications = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);

  // mark all seen
  const markAllSeen = async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/user/mark-all-notifications-seen",
        { userId: user._id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        dispatch(setUser(response.data.data));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  // delete all
  const deleteAll = async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/user/delete-all-notifications",
        { userId: user._id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        dispatch(setUser(response.data.data));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      {/* Button to trigger drawer */}
      <Button type="primary" onClick={showDrawer}>
        View Notifications
      </Button>

      <Drawer
        title="🔔 Notifications"
        placement="right"
        width={420}
        onClose={onClose}
        open={open}
      >
        <Tabs defaultActiveKey="0">
          {/* Unseen Notifications */}
          <Tabs.TabPane tab="Unseen" key="0">
            <div className="d-flex justify-content-end mb-2">
              <Button type="link" onClick={markAllSeen}>
                Mark all as seen
              </Button>
            </div>
            {user?.unseenNotifications.length === 0 && <p>No new notifications.</p>}
            {user?.unseenNotifications.map((notification) => (
              <div
                className="card p-2 mt-2"
                key={notification._id}
                onClick={() => {
                  if (user.isAdmin) navigate("/admin/doctorslist");
                  else if (user.isDoctor) navigate("/doctor/reviews");
                }}
              >
                <div className="card-text">{notification.message}</div>
              </div>
            ))}
          </Tabs.TabPane>

          {/* Seen Notifications */}
          <Tabs.TabPane tab="Seen" key="1">
            <div className="d-flex justify-content-end mb-2">
              <Button type="link" onClick={deleteAll}>
                Delete All
              </Button>
            </div>
            {user?.seenNotifications.length === 0 && <p>No seen notifications.</p>}
            {user?.seenNotifications.map((notification) => (
              <div
                className="card p-2 mt-2"
                key={notification._id}
                onClick={() => {
                  if (user.isAdmin) navigate("/admin/doctorslist");
                  else if (user.isDoctor) navigate("/doctor/reviews");
                }}
              >
                <div className="card-text">{notification.message}</div>
              </div>
            ))}
          </Tabs.TabPane>
        </Tabs>
      </Drawer>
    </>
  );
};

export default Notifications;
